export function KidSafeSeal() {
  return (
    <a
      href="https://kidsafe.com/member/Readingeggs_websites"
      target="_blank"
      rel="noreferrer"
    >
      <img
        alt="Reading Eggs Websites are certified by the kidSAFE Seal Program."
        src="https://marketing-cdn.3plearning.com/uploads/assets/readingeggs-pflw/kidsafe-safe-certified-seal.png"
        className="w-[140px]"
      />
    </a>
  )
}
